import { useEffect } from "react";
import { motion } from "framer-motion";
import { BRAND } from "../config/brand";

export const Splash = ({ onDone }) => {
  useEffect(() => {
    let seen = false;
    try { seen = sessionStorage.getItem("synrise-splash") === "1"; sessionStorage.setItem("synrise-splash", "1"); } catch (e) {}
    const t = setTimeout(onDone, seen ? 450 : 1700);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="splash-screen"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
      exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1] } }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative h-28 w-28"
      >
        <span className="absolute inset-2 animate-ping-slow rounded-full border border-orange-400/30" />
        <img src={BRAND.logo} alt="SYNrise" className="relative h-full w-full object-contain drop-shadow-[0_0_30px_rgba(249,115,22,0.5)]" />
      </motion.div>
      <div className="mt-8 overflow-hidden">
        <motion.p
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.25, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-3xl font-bold tracking-tight text-zinc-50"
        >
          SYN<span className="font-serif text-[1.15em] font-normal italic text-gold">rise</span>
        </motion.p>
      </div>
      <div className="mt-6 h-px w-36 overflow-hidden bg-white/10">
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: "0%" }}
          transition={{ duration: 1.4, ease: [0.65, 0, 0.35, 1] }}
          className="h-full w-full bg-gold"
        />
      </div>
    </motion.div>
  );
};
